import { Module } from "vuex";
import { RootState } from "../types";
import { telegramOtpStatistic } from "./statistic";
import { telegramOtpSend } from "./send";

export const telegramOtpModule: Module<void, RootState> = {
  modules: {
    telegramOtpStatistic,
    telegramOtpSend,
  },
};
